/* pv-cta-scroll.js
   The cod-lander CTAs (hero "สั่งเลย เก็บเงินปลายทาง" and the sticky bar) render with
   href="#" whenever the concept's own order box is hidden, so a tap does nothing.
   Point them at whichever COD form the page actually has and glide there.

   Scoped on purpose: only .codx-cta / .codx-sticky__btn (the cod-lander section).
   Landers whose anchors already resolve to a real order box keep their own behaviour,
   and a CTA the EasySell app-embed path claimed (data-pv-rewired) is left alone. */
(function () {
  var CTA = '.codx-cta, .codx-sticky__btn';

  function formEl() {
    return document.querySelector('#es-form-container')
        || document.querySelector('.es-form-container')
        || document.querySelector('#es-form-hook')
        || document.querySelector('form.es-form')
        || document.querySelector('[id$="-order"], .codmv-order, .codsp-order');
  }

  // A fixed/sticky bar pinned to the top would otherwise cover the form heading.
  function headroom() {
    var h = 0;
    var bars = document.querySelectorAll('.codx-topbar, .codx-cd-top, .codx-header, header');
    for (var i = 0; i < bars.length; i++) {
      var el = bars[i], cs = window.getComputedStyle(el), r = el.getBoundingClientRect();
      if ((cs.position === 'fixed' || cs.position === 'sticky') && r.top <= 4 && r.height) {
        h = Math.max(h, r.height);
      }
    }
    return h;
  }

  function targetY(el, offset) {
    var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
    var max = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
    return Math.max(0, Math.min(top, max));
  }

  document.addEventListener('click', function (ev) {
    var el = ev.target && ev.target.closest ? ev.target.closest(CTA) : null;
    if (!el || el.hasAttribute('data-pv-rewired')) return;

    var target = formEl();
    if (!target) return;   // nothing to scroll to — leave the link as it was

    ev.preventDefault();

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var offset = headroom() + 16;
    var want = targetY(target, offset);
    var from = window.pageYOffset;

    if (reduce) {
      window.scrollTo(0, want);
    } else {
      try {
        window.scrollTo({ top: want, behavior: 'smooth' });
      } catch (e) {
        window.scrollTo(0, want);
      }
      // Smooth scrolling is suspended in a background tab and in a few older browsers,
      // which would leave the tap doing nothing at all. If we have not moved shortly
      // after, jump there instead — landing late beats not landing.
      window.setTimeout(function () {
        if (Math.abs(window.pageYOffset - from) < 4 && Math.abs(want - from) > 4) {
          window.scrollTo(0, targetY(target, offset));
        }
      }, 450);
    }

    // Put the cursor in the first field, but only with a mouse — on a phone this
    // would throw the keyboard up mid-scroll and hide the form the tap asked for.
    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      window.setTimeout(function () {
        var field = target.querySelector('input:not([type="hidden"]):not([disabled]), textarea');
        if (field) { try { field.focus({ preventScroll: true }); } catch (e) { field.focus(); } }
      }, reduce ? 0 : 700);
    }
  });
})();
